import { useMemo, useState } from 'react'
import { usePreloadImages } from '../../../../../utils/image-loading/usePreloadImages'
import { GROUPED_STATIC_TEXT_ROLE } from '../../../../ui-components/NameValueTableRow'

export const RankTrendsPointer = () => {
  const [outsideAssetWidth, setOutsideAssetWidth] = useState(0)
  const assetRatio = 0.644

  const bgAssetHeight = useMemo(() => {
    return outsideAssetWidth * (assetRatio ?? 1) || 700
  }, [outsideAssetWidth])

  const powerRankTrendsImage = '/images/elite/power_rank_trends_pointer.svg'

  usePreloadImages([powerRankTrendsImage])

  return (
    <div className='flex gap-4 justify-between'>
      <div className='flex h-10 w-10' aria-hidden='true'>
        <img src='/images/elite/rank_trends_pointer_icon.svg' alt='' />
      </div>
      <div className='flex flex-col flex-1 w-1'>
        <h3
          role={GROUPED_STATIC_TEXT_ROLE}
          aria-label='Rank trends for effortless Portfolio Review'
          className='text-[16px] text-black font-[700] m-0'
        >
          <span aria-hidden='true'>
            Rank trends <span className='opacity-60 font-[400]'> for effortless Portfolio Review </span>
          </span>
        </h3>
        <div
          role={GROUPED_STATIC_TEXT_ROLE}
          aria-label='See if your fund is improving or not. Track its rank over past 24 months — not just today.'
          className='pt-1 text-[13px] text-[#6A6E6E]'
        >
          <span aria-hidden='true'>
            See if your fund is improving or not. Track its rank over past 24 months — not just today.
          </span>
        </div>

        <div className='flex w-full justify-center pt-6 pb-5'>
          <div className='w-full'>
            <div
              ref={(ref) => {
                if (ref && outsideAssetWidth === 0) {
                  setOutsideAssetWidth(ref?.clientWidth ?? 300)
                }
              }}
              style={{ height: bgAssetHeight }}
              className='w-full h-max'
            >
              <img
                src={powerRankTrendsImage}
                className='w-full h-auto'
                alt='Graph showing fund performance trends'
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
